import { Route } from '@angular/router';
import { unsavedChangesGuard } from 'src/lib/guards/unsaved-changes.guard';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import {
  PACKAGEGOODS_API,
  PackagegoodsKey,
  PackagegoodsTypeConfig,
} from './packagegoods.types';

/**
 * Packagegoods Route Factory (Board 패턴 동일)
 *
 * Config-Driven으로 타입별 라우트를 자동 생성합니다.
 *
 * - providers로 타입별 API를 PACKAGEGOODS_API 토큰에 바인딩
 * - data로 config를 Smart 컴포넌트에 전달
 * - canActivate로 권한 가드 적용
 */
export function createPackagegoodsRoute(
  key: PackagegoodsKey,
  config: PackagegoodsTypeConfig,
): Route {
  return {
    path: config.routePath,
    canActivate: [
      ...(config.permissions?.map((p) => permissionGuard(p as any)) ?? []),
    ],
    providers: [{ provide: PACKAGEGOODS_API, useExisting: config.apiClass }],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import(
            '../components/smart/packagegoods-list-page/packagegoods-list-page.component'
          ).then((m) => m.PackagegoodsListPageComponent),
        data: {
          packagegoodsKey: key,
          config,
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                '../components/smart/packagegoods-detail-page/packagegoods-detail-page.component'
              ).then((m) => m.PackagegoodsDetailPageComponent),
            data: {
              packagegoodsKey: key,
              config,
            },
          },
        ],
      },
    ],
  };
}
